export default __webpack_public_path__ + "static/media/plus.39d157d8.png";